import { render, staticRenderFns } from "./ModalComments.vue?vue&type=template&id=55824556"
import script from "./ModalComments.vue?vue&type=script&lang=js"
export * from "./ModalComments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports